/**
 * Form income liabilities popup script
 */
 class FinHub_FormIncomesLiabilitiesPopup {
  constructor() {
    this.initState();
  }

  initState() {
    this.stepIncomesLiabilitiesPopup = $('.incomes-liabilities-popup');

    if (this.stepIncomesLiabilitiesPopup.length) {
      this.initFormIncomesLiabilities();
    }
  }

  initFormIncomesLiabilities () {
    this.stepFormIncomesLiabilitiesPopup = $('.form-incomes-liabilities-popup');
    let formHelperIncomesLiabilitiesPopup = new FinHub_FormHelper(this.stepFormIncomesLiabilitiesPopup);
    this.addNewLiabilities = $('.step-income').find('.add-new-liabilities');
    this.cancelNewLiabilities = this.stepIncomesLiabilitiesPopup.find('.cancel-submit');
    this.submitPopup = this.stepFormIncomesLiabilitiesPopup.find('.form-incomes-liabilities-popup-submit');
    let liabilitiesWithBankIDs = [];
    this.stepFormIncomesLiabilitiesPopup.find('input[data-show-bank-select="1"]').each((i, field) => {
      liabilitiesWithBankIDs.push($(field).val());
    });
    
    formHelperIncomesLiabilitiesPopup.formDependencies([
      {
        field: 'bank_id',
        dependsOn: 'input[name="liability_id"]',
        showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
      },    
      {
        field: 'incomes-liabilities-payoff_amount_currency_name',
        dependsOn: 'select[name="incomes-liabilities-payoff_amount_currency_id"]',
        showOn: () => {
          let selectedCurrency = this.stepFormIncomesLiabilitiesPopup.find('select[name="incomes-liabilities-payoff_amount_currency_id"]').find(":selected");

          if (!selectedCurrency.length) {
            return false;
          }

          let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
          return selectedCurrencyCode === 'OTHER';
        }
      },    
      {
        field: 'incomes-liabilities-instalment_amount_currency_name',
        dependsOn: 'select[name="incomes-liabilities-instalment_amount_currency_id"]',
        showOn: () => {
          let selectedCurrency = this.stepFormIncomesLiabilitiesPopup.find('select[name="incomes-liabilities-instalment_amount_currency_id"]').find(":selected");

          if (!selectedCurrency.length) {
            return false;
          }

          let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
          return selectedCurrencyCode === 'OTHER';
        }
      }
    ]);

    this.cancelNewLiabilities.on('click', e => {
      e.preventDefault();
      this.stepIncomesLiabilitiesPopup.addClass('is-hidden');
      this.stepFormIncomesLiabilitiesPopup[0].reset();
      $("*[data-fh-name]").addClass('is-hidden');
    });

    this.submitPopup.on('click', e => {
      e.preventDefault();
      let result = formHelperIncomesLiabilitiesPopup.formValidate();

			if (result) {
        let serializedData = this.stepFormIncomesLiabilitiesPopup.serializeArray();
        serializedData = this.serializeArrayToJSON(serializedData);
        let indexToUse = parseInt(this.stepIncomesLiabilitiesPopup.attr('data-index'), 10);
        $(document).trigger('finhub-add-income-liability', [serializedData, indexToUse]);
        this.cancelNewLiabilities.trigger('click');
			}
    });
  }

  serializeArrayToJSON (arrayToConvert) {
    let outputJSON = {};

    for (let i = 0; i < arrayToConvert.length; i++) {
      let pair = arrayToConvert[i];

      if (pair.value === '' || pair.value === null) {
        continue;
      }
      
      outputJSON[pair.name] = pair.value;
    }

    return JSON.stringify(outputJSON);
  }
}